import { IconPlus } from "@tabler/icons-react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { IGenericLoginsRow } from "src/components/pages/Settings/GenericLogins/GenericLogins.types";
import GenericLoginsRow from "src/components/pages/Settings/GenericLogins/GenericLoginsRow";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";
import { useGetApi } from "src/hooks";
import { ButtonsWrapper, PageContainer } from "src/styled";
import { getYachtId } from "src/utils";

import { headers } from "./GenericLoginsHeaders";

const mapper = (data: any) => {
  if (!data?.list) return [];
  return Object.values(data.list) as IGenericLoginsRow[];
};

const GenericLogins = () => {
  const navigate = useNavigate();

  const { data } = useGetApi({
    request: "get-generic-logins",
    body: {
      params: { yachtid: getYachtId() },
    },
    mapper,
  });
  const handleAddLogin = () => {
    navigate("./add-login");
  };
  const renderRow = useCallback(
    ({ row }: { row: IGenericLoginsRow }) => <GenericLoginsRow {...row} />,
    [],
  );

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonsWrapper>
          <Button
            onClick={handleAddLogin}
            leftSection={<IconPlus size="1.4rem" />}>
            Add
          </Button>
        </ButtonsWrapper>
      </Breadcrumbs>
      <div style={{ maxWidth: "1000px", width: "auto", margin: "0 auto" }}>
        <ScrollableTable
          data={data}
          keyExtractor={item => item.userid}
          headers={headers}
          renderRow={renderRow}
        />
      </div>
    </PageContainer>
  );
};
export default GenericLogins;
